export default class TournamentMenu {
  constructor() {
    this.header = document.querySelector('.tournament-header');
    this.button = this.header?.querySelector('.tournament-header__toggle');

    if (!this.button) {
      this.header = null;
      return;
    }

    this.onToggle = () => this.set(!this.header.classList.contains('is-open'));
    this.onLink = (e) => e.target.closest('a') && this.set(false);
    this.onKey = (e) => e.key === 'Escape' && this.set(false);
    this.onOutside = (e) => !this.header.contains(e.target) && this.set(false);

    this.button.addEventListener('click', this.onToggle);
    this.header.addEventListener('click', this.onLink);
    document.addEventListener('keydown', this.onKey);
    document.addEventListener('pointerdown', this.onOutside);
  }

  set(open) {
    this.header.classList.toggle('is-open', open);
    this.button.setAttribute('aria-expanded', String(open));
  }

  destroy() {
    if (!this.header) {
      return;
    }

    this.button.removeEventListener('click', this.onToggle);
    this.header.removeEventListener('click', this.onLink);
    document.removeEventListener('keydown', this.onKey);
    document.removeEventListener('pointerdown', this.onOutside);
  }
}
